/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgRepeat = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      d="M22 13v6H5.602L7 20.474 5.553 22 2 18l3.553-4L7 15.526 5.601 17H20v-4zM18.447 2 22 6l-3.553 4L17 8.474 18.399 7 4 7.001V11H2V5h16.398L17 3.526z"
      fill="currentcolor"
      fillRule="evenodd"
    />
  </Icon>
);
export { SvgRepeat as Repeat };
